module.exports = __webpack_public_path__ + "static/media/logo-2.a0336c6f.png";